
export default {
  props: {
    item: {
      type: String,
      required: true,
    },
  },
}
